import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  DeleteRoleMutation,
  DeleteRoleMutationVariables
} from "../../__generated__/types";
import { DELETE_ROLE_QUERY } from "./queries";
import { ROLES_QUERY } from "src/queries/RolesQuery/queries";
import { ApolloError } from "apollo-client";

class DeleteRoleM extends Mutation<DeleteRoleMutation> {}

export interface Props {
  onError?: (error: ApolloError) => void;
  onCompleted?: (data: DeleteRoleMutation) => void;
  children(
    props: MutationFn<DeleteRoleMutation, DeleteRoleMutationVariables>
  ): JSX.Element | null;
}

export interface State {}

export default class DeleteRole extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <DeleteRoleM
        mutation={DELETE_ROLE_QUERY}
        refetchQueries={[{ query: ROLES_QUERY }]}
        awaitRefetchQueries={true}
        onError={this.props.onError}
        onCompleted={this.props.onCompleted}
      >
        {(mutation, result) => this.props.children(mutation)}
      </DeleteRoleM>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/DeleteRole/DeleteRole.tsx